import { createSelector } from 'reselect'

import { selectConfigurationState } from './selectConfigurationState'

export const selectCurrency = createSelector([selectConfigurationState], (state) => state.currency)
